import {
  IEquipmentType,
  useInfiniteQueryUserLibraryMyWorkouts,
  useQueryUserLibraryMyWorkouts,
} from '@ifit/gateway-wolf-athenaeum-service';
import { useInfiniteQueryOptions, useRowQueryOptions } from '../query-options';
import { useEquipmentType } from '../equipment-type';
import getNextPageParam from '../get-next-page';

export const useMyWorkoutsRowQuery = () => {
  const opts = useRowQueryOptions();
  const { equipmentType } = useEquipmentType();

  return useQueryUserLibraryMyWorkouts(opts, {
    enabled:
      equipmentType !== null && equipmentType !== IEquipmentType.Strength,
  });
};

export const useMyWorkoutsInfiniteQuery = () => {
  const opts = useInfiniteQueryOptions();
  const { equipmentType } = useEquipmentType();

  return useInfiniteQueryUserLibraryMyWorkouts(opts, {
    enabled:
      equipmentType !== null && equipmentType !== IEquipmentType.Strength,
    getNextPageParam,
  });
};
